export default {
      id: "lattice-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#lattice",
      toString: function () {
        return this.url;
      }
    }